import moment from "moment";
import {message} from "antd";
import { INTERCOM_PROVIDER, ZENDESK_PROVIDER } from "components/swifteq/Helpdesk/Connect/utils";

export default function getSubdomainTask(dataset, task_name, subdomain) {
  const tasks = (dataset || {}).tasks || {};
  const taskData = tasks[task_name] || {};

  if (!subdomain) {
    return taskData;
  }

  const subdomainKey = subdomain.replace(/\./g, '_');
  return taskData[subdomainKey] || {};
}

export function trimIfLong(s, max_Len) {
  s = s || ''
  max_Len = max_Len || 100
  return s.substring(0, max_Len) + (s.length > max_Len ? '...' : '')
}

export function escapeSpecialRegex(s) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function trackEvent(event_name, event_props) {
  window.amplitude && window.amplitude.track(event_name, event_props || {});
}

export function computeQueryParams(filters) {
  let queryParams = {}
  if (filters && filters.length > 0) {
    filters.forEach((filter) => {
      const isReadingFilter = filter.type === 'rt_gt' || filter.type === 'rt_lt'
      if(filter && isReadingFilter && filter.value !== null) {
        queryParams[filter.type] = [filter.value]
      }
      if (filter && filter.value && filter.value.length > 0) {
        if (filter.type === 'ts_from' || filter.type === 'ts_to') {
          queryParams[filter.type] = [moment(filter.value[0]).format('YYYY-MM-DD HH:mm:ss')]
        }
        else {
          queryParams[filter.type] = filter.value
        }
      }
    })
  }

  let query = '?'

  Object.keys(queryParams).forEach((key, keysIndex) => {
    let toConcat = `${key}=`
    queryParams[key].forEach((val, index) => {
      toConcat += `${val}${index === queryParams[key].length - 1
        ? keysIndex === Object.keys(queryParams).length - 1
          ? ''
          : '&'
        : ','
        }`
    })
    query += toConcat
  })

  return query
}

export function capitalizeFirstLetter(string) {
  string = string || ""
  return (string.length > 0) ? string.charAt(0).toUpperCase() + string.slice(1) : "";
}


export function checkTaskRunning(dataset, subdomain) {
  let task_running = false;
  const subdomain_name = (subdomain || '').replace(/\./g, '_');
  Object.keys((dataset?.tasks || {})).forEach((k) => {
    const task = (subdomain_name) ? dataset.tasks[k][subdomain_name] : dataset.tasks[k];
    if (k !== 'hcm_load_tickets' && task && task.status === 'running') {
      task_running = true;
    }
  })
  return task_running;
}

export function copyArticleId (e, id, textMessage) {
  e.stopPropagation()
  const textarea = document.createElement('textarea');
  textarea.value = id;

  document.body.appendChild(textarea);

  textarea.select();
  textarea.setSelectionRange(0, textarea.value.length);

  document.execCommand('copy');

  document.body.removeChild(textarea);
  message.info(textMessage || "The Article ID was copied to clipboard.");
}

export function isViewOnly(user) {
  return user?.['https://www.swifteq.com/role'] === 'view-only';
}

export function isOwner(user) {
  return user?.['https://www.swifteq.com/role'] === 'owner';
}

export function getArticleUrl(article, dataset_source, connector) {
  if (dataset_source === ZENDESK_PROVIDER) {
    const subdomain = connector?.auth?.subdomain;

    if (!subdomain) {
      console.error("Zendesk subdomain is missing in the connector auth.");
      return article.sq_url || "#";
    }

    return `https://${subdomain}.zendesk.com/knowledge/articles/${article.source_id || article.sq_id?.split('_')[0]}/${article.sq_lang}`;
  }

  if (dataset_source === INTERCOM_PROVIDER) {
    console.log("Intercom Article", connector);
    return `https://app.intercom.com/a/apps/${connector?.auth?.workspace_id}/knowledge-hub/all-content?activeContentType=article&editorMode=view&search=${encodeURIComponent(article.title)}`;
  }

  return "#";
}

export function getSectionUrl(subdomain, locale, section_id) {
  return `https://${subdomain}/hc/${locale}/sections/${section_id}`
}

export function getCategoryUrl(subdomain, locale, category_id) {
  return `https://${subdomain}/hc/${locale}/categories/${category_id}`
}
